<template>
	<button
		@click="isPlaying ? store.togglePlay() : store.playEpisode(episode, podcast)"
		class="w-9 h-9 relative rounded-full border border-white flex justify-center items-center hover:bg-red hover:border-red !cursor-pointer text-white"
		:class="{ '!bg-red !border-red' : isPlaying }"
	>
		<svg v-if="!isPlaying" class="w-full h-full z-50 p-1" viewBox="2 2 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path id="Path" fill="currentColor" fill-rule="evenodd" stroke="none" d="M 8.97742 7.86322 C 8.97742 7.40527 9.52525 7.083389 9.96072 7.36795 L 9.96083 7.368019 L 16.340401 11.5344 L 16.3403 11.5345 L 16.347799 11.5392 C 16.510099 11.6411 16.6141 11.8266 16.6133 12.032 C 16.6126 12.2375 16.5072 12.4221 16.344299 12.5226 L 16.3442 12.5226 L 16.336399 12.5276 L 9.95682 16.633499 L 9.95665 16.6336 C 9.5207 16.9144 8.97742 16.5942 8.97742 16.135401 Z M 7.97742 7.86322 C 7.97742 6.56806 9.44312 5.83526 10.5076 6.53076 L 10.5077 6.53083 L 16.883801 10.6949 C 17.342199 10.9849 17.615299 11.494 17.6133 12.0358 C 17.6113 12.5774 17.334499 13.0844 16.874001 13.3708 L 10.4982 17.4743 C 9.43413 18.1597 7.97742 17.429899 7.97742 16.135401 Z"/>
		</svg>
		<svg v-if="isPlaying" class="w-full h-full z-50 p-1" viewBox="2 2 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path id="Path" fill="currentColor" fill-rule="evenodd" stroke="none" d="M 9.05961 7.5 C 9.33575 7.5 9.55961 7.72386 9.55961 8 L 9.55961 15.8577 C 9.55961 16.133801 9.33575 16.3577 9.05961 16.3577 C 8.78347 16.3577 8.55961 16.133801 8.55961 15.8577 L 8.55961 8 C 8.55961 7.72386 8.78347 7.5 9.05961 7.5 Z M 15.5596 8 C 15.5596 7.72386 15.3358 7.5 15.0596 7.5 C 14.7835 7.5 14.5596 7.72386 14.5596 8 L 14.5596 15.8577 C 14.5596 16.133801 14.7835 16.3577 15.0596 16.3577 C 15.3358 16.3577 15.5596 16.133801 15.5596 15.8577 Z"/>
		</svg>
		<div class="progress-circle" :style="`--percent: ${playbackPercentage}%;`"></div>
	</button>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { usePodcastStore } from '../stores/podcastStore'

const store = usePodcastStore()

const props = defineProps({
	episode: {
		type: Object,
		required: true
	}
})

const podcast = computed(() => {
	return store.getPodcastByEpisodeLinkid(props.episode.linkid)
})

const continueEpisode = computed(() => {
	return store.playbackPositions[props.episode.linkid] || 0
})

const playbackPercentage = computed(() => {
	const total = props.episode.seconds || 0
	const current = continueEpisode.value || 0
	
	if (total === 0) return 0
	
	const percentage = (current / total) * 100
	
	// 1. Dividera med 10, avrunda uppåt med Math.ceil, och multiplicera med 10
	const roundedUpToTen = Math.ceil(percentage / 10) * 10
	
	// 2. Se till att det inte kan bli mer än 100%
	return Math.min(roundedUpToTen, 100)
})

const isPlaying = computed(() => {
	return store.currentEpisode?.linkid === props.episode.linkid && store.isPlaying
})

</script>
